/**
 * ScreenShake — wrapper that jitters children when triggered
 */

import { type ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useReducedMotion } from '../../hooks/useReducedMotion';

interface ScreenShakeProps {
  trigger: boolean;
  intensity?: number;
  children: ReactNode;
}

export default function ScreenShake({
  trigger,
  intensity = 1,
  children,
}: ScreenShakeProps) {
  const reduced = useReducedMotion();

  if (reduced || !trigger) {
    return <>{children}</>;
  }

  const s = intensity;

  return (
    <motion.div
      animate={{
        x: [0, -4 * s, 4 * s, -2 * s, 2 * s, 0],
        y: [0, 2 * s, -2 * s, 1 * s, 0, 0],
      }}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
    >
      {children}
    </motion.div>
  );
}
